export default [
  {
    header: 'Inicio',
    icon: 'HomeIcon',
    children: [
      {
        title: 'Dashboard',
        route: 'dashboard-inicio',
        icon: 'ActivityIcon',
      },
    ],
  },
]
